import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { computed, observable } from 'mobx';
import copy from '@src/components/copy';
import { useRequest } from 'ahooks';
import getFooterYear from '@src/utils/get-footer-year';
import goToShare from '@src/utils/share';

import useModal from '@src/utils/hooks/use-modal';
import CookieTipsModal from '@src/components/cookie-modal/cookie-tips-modal';
import { autobind } from 'core-decorators';
import CookieTipsModalStore, { COOKIE_FLAG } from '@src/components/cookie-modal/cookie-tips-modal/store';
import Cookie from '@src/utils/cookie';
import { useEffect } from 'react';

import LanguageSelectStore from '../language-select/store';

// import ShareLinkStore from '@src/mobx-store/component-store/share-link-store';

class FooterStore extends BaseStore {
  cookieTipModalStore = new CookieTipsModalStore();
  languageSelectStore = new LanguageSelectStore();

  // shareLinkStore = ShareLinkStore().getInstance();
  @observable wxActive = false;

  @observable qqgroup_link = '';

  @observable qqActive = false;
  // 当前年份
  @observable currentYear;

  @observable cookieFlagInfo;

  @observable isActive = false;
  /**
   * 是否允许cookies
   * @type {{analytics: boolean, necessary: boolean}}
   */
  @observable
  acceptCookies = {
    necessary: true,
    analytics: false
  };

  selectQq(type) {
    this.wxActive = false;
    this.qqgroup_link = window.mechabreakConfig[type];
    this.qqActive = !this.qqActive;
  }

  selectWx() {
    this.qqActive = false;
    this.wxActive = !this.wxActive;
  }

  copyLink() {
    copy(window.location.href, {
      successPreText: '复制成功',
      showText: false
    });
  }

  /**
   * 跳转链接
   * @param {string} type -  分享变量名
   */
  shareLink(type) {
    goToShare(type);
  }

  /**
   * 是否存在CookieFlag
   * @returns {boolean}
   */
  @computed
  get hasCookieFlag() {
    return !!this.cookieFlagInfo;
  }

  /**
   * 获取年份
   * @returns {Promise<void>}
   */
  async getYear() {
    try {
      const year = await this.getCurrentYearRequest.run();
      this.currentYear = year;
    } catch (e) {
      // console.log(e);
    }
  }

  @autobind
  getCookieFlag() {
    this.cookieFlagInfo = Cookie.get(COOKIE_FLAG);
  }

  @autobind
  onCookieSettingsBtnClick() {
    this.reInit();
    this.cookieTipModalStore.isDirectToSettingModal = true;
    this.cookieTipModal.open({ extraProps: { store: this.cookieTipModalStore } });
  }
  @autobind
  reInit() {
    this.getCookieFlag();
    if (this.hasCookieFlag) {
      const info = JSON.parse(this.cookieFlagInfo);
      this.acceptCookies.necessary = info.necessary;
      this.acceptCookies.analytics = info.analytics;
    }
  }
  /**
   * 初始化
   */
  @autobind
  init() {
    if (this.hasCookieFlag) {
      const info = JSON.parse(this.cookieFlagInfo);
      this.acceptCookies.necessary = info.necessary;
      this.acceptCookies.analytics = info.analytics;
    } else {
      setTimeout(() => {
        this.cookieTipModal.open();
      }, 2000);
    }
  }

  use() {
    super.use();
    this.getCurrentYearRequest = useRequest(async () => await getFooterYear(), { manual: true, throwOnError: true });
    this.cookieTipModal = useModal(CookieTipsModal);
    useMount(async () => {
      // console.log('componentDidMount');
      this.getYear();
      this.getCookieFlag();
      this.init();
      // this.cookieSettingModal.open();
    });
    useEffect(
      () => {
        this.cookieTipModalStore.acceptCookies.analytics = this.acceptCookies.analytics;
        this.cookieTipModalStore.acceptCookies.necessary = this.acceptCookies.necessary;
      },
      [this.acceptCookies.analytics, this.acceptCookies.necessary]
    );
    useEffect(
      () => {
        if (!this.isActive) {
          this.languageSelectStore.onExpandListStatusChange(false);
        }
      },
      [this.isActive]
    );
  }
}

export default FooterStore;
